<template>
  <label
    class="uppercase text-gray-500 tracking-widest text-xs mb-1 block dark:bg-gray-900"
  >
    <slot />
  </label>
</template>
